export const usePlacementManager = (handleForm: any) => {
    const commonSizes = [
        [300, 250], [336, 280], [728, 90], [970, 90], 
        [320, 50], [300, 600], [160, 600], [970, 250]
    ];

    const addPlacement = (type: string) => {
        const currentPlacements = handleForm.values.placements || [];
        const newPlacement = {
            type,
            enabled: true,
            adUnitPath: '',
            selector: type === 'anchor' ? 'body' : '',
            refresh: 30,
            provider: 'adp',
            sizes: [[300, 250]],
            pos: type === 'anchor' ? 3 : 1,
            all: ['in-feed'].includes(type),
            index: ['anchor', 'billboard'].includes(type) ? 0 : null,
            attributes: '{}',
            ...(type === 'anchor' && { position: 'bottom' }),
            ...(type === 'slider' && { position: 'right' }),
            ...(type === 'corner' && { position: 'right', verticalPosition: 'bottom' })
        };
        handleForm.setFieldValue('placements', [...currentPlacements, newPlacement]);
    };

    const removePlacement = (index: number) => {
        const currentPlacements = handleForm.values.placements || [];
        handleForm.setFieldValue('placements', currentPlacements.filter((_: any, i: number) => i !== index));
    };

    const updatePlacement = (index: number, field: string, value: any) => {
        const currentPlacements = [...handleForm.values.placements];
        currentPlacements[index] = { ...currentPlacements[index], [field]: value };
        handleForm.setFieldValue('placements', currentPlacements);
    };

    const addCustomSize = (placementIndex: number, isCustom: boolean = false) => {
        const fieldName = isCustom ? 'customPlacements' : 'placements';
        const currentPlacements = [...handleForm.values[fieldName]];
        const currentSizes = currentPlacements[placementIndex].sizes || [];
        currentSizes.push([300, 250]);
        if (isCustom) {
            updateCustomPlacement(placementIndex, 'sizes', currentSizes);
        } else {
            updatePlacement(placementIndex, 'sizes', currentSizes);
        }
    };

    const removeCustomSize = (placementIndex: number, sizeIndex: number, isCustom: boolean = false) => {
        const fieldName = isCustom ? 'customPlacements' : 'placements';
        const currentPlacements = [...handleForm.values[fieldName]];
        const currentSizes = [...currentPlacements[placementIndex].sizes];
        currentSizes.splice(sizeIndex, 1);
        if (isCustom) {
            updateCustomPlacement(placementIndex, 'sizes', currentSizes);
        } else {
            updatePlacement(placementIndex, 'sizes', currentSizes);
        }
    };

    const addCustomPlacement = () => {
        const currentPlacements = handleForm.values.placements || [];
        const newPlacement = {
            type: 'custom',
            name: 'Custom Format',
            enabled: true,
            adUnitPath: '',
            selector: '',
            refresh: 30,
            provider: 'adp',
            sizes: [[300, 250]],
            pos: 1,
            all: false,
            index: 0,
            attributes: {}
        };
        handleForm.setFieldValue('placements', [...currentPlacements, newPlacement]);
    };

    const removeCustomPlacement = (index: number) => {
        const currentPlacements = handleForm.values.placements || [];
        handleForm.setFieldValue('placements', currentPlacements.filter((_: any, i: number) => i !== index));
    };

    const updateCustomPlacement = (index: number, field: string, value: any) => {
        const currentPlacements = [...handleForm.values.placements];
        currentPlacements[index] = { ...currentPlacements[index], [field]: value };
        handleForm.setFieldValue('placements', currentPlacements);
    };

    // Gerenciar blocked pages
    const addBlockedPage = () => {
        const currentPages = handleForm.values.blockedPages || [];
        handleForm.setFieldValue('blockedPages', [...currentPages, { name: '', type: 'path', pattern: '', enabled: true }]);
    };

    const removeBlockedPage = (index: number) => {
        const currentPages = handleForm.values.blockedPages || [];
        handleForm.setFieldValue('blockedPages', currentPages.filter((_: any, i: number) => i !== index));
    };

    // Gerenciar third party scripts
    const addThirdPartyScript = () => {
        const currentScripts = handleForm.values.thirdPartyScripts || [];
        handleForm.setFieldValue('thirdPartyScripts', [...currentScripts, {
            name: '',
            type: 'script',
            inputType: 'url',
            enabled: true,
            deliveryPercentage: 100,
            src: '',
            text: '',
            format: '',
            formatIndex: 0
        }]);
    };

    const removeThirdPartyScript = (index: number) => {
        const currentScripts = handleForm.values.thirdPartyScripts || [];
        handleForm.setFieldValue('thirdPartyScripts', currentScripts.filter((_: any, i: number) => i !== index));
    };

    return {
        commonSizes,
        addPlacement,
        removePlacement,
        updatePlacement,
        addCustomSize,
        removeCustomSize,
        addCustomPlacement,
        removeCustomPlacement,
        updateCustomPlacement,
        addBlockedPage,
        removeBlockedPage,
        addThirdPartyScript,
        removeThirdPartyScript
    };
};